import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {DateRangePicker} from '@blueprintjs/datetime'
import {Accordion, AccordionDetails, AccordionSummary} from '@material-ui/core'
import {KeyboardArrowDown} from '@material-ui/icons'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './DatePicker.css'

/// region Store

export class DatePickerStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  get label() {
    return this.props.label
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const DatePickerStoreContext = React.createContext<DatePickerStore>(null)
export const useDatePickerStore = () => React.useContext(DatePickerStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  label: string
}

export const DatePicker = observer<MyProps>(function DatePicker({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new DatePickerStore(stores, obsProps)),
    {label} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <DatePickerStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <Accordion elevation={0} classes={{expanded: css.expanded}}>
          <AccordionSummary data-type={'summary-date-field'} expandIcon={<KeyboardArrowDown/>}>
            <div className={css.label}>
              <div>{label}</div>
              <div className={css.date}>Start date:&nbsp;<span data-type='value'>Feb 29, 2021</span></div>
              <div className={css.date}>End date:&nbsp;<span data-type='value'>Not set</span></div>
            </div>
          </AccordionSummary>
          <AccordionDetails data-type={'details-date-field'}>
            <DateRangePicker shortcuts={false} highlightCurrentDay maxDate={new Date()}/>
          </AccordionDetails>
        </Accordion>
      </div>
    </DatePickerStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/common/components/DatePickerAccordion/DatePicker.tsx